module.exports = __webpack_public_path__ + "img/b2bpro.867b31df.png";